import React, { Component } from 'react';
import blogposts from '../../blogposts/';

class BlogPost extends Component {
  render() {
    const result = blogposts.find(
      (post) => post.path === this.props.match.params.postID
    );
    const Blog = result.component;
    return (
      <div className="blogpost">
        <Blog
          locations={{
            next: result.next,
            previous: result.previous,
          }}
        />
      </div>
    );
  }
}

export default BlogPost;



// WEBPACK FOOTER //
// ./src/components/common/BlogPost.js